import React from 'react'
import { Trash2 } from 'lucide-react'

const icon = props => <Trash2 size={18} {...props} />

export default icon
